import { useEffect, type Dispatch, type SetStateAction } from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import radialImg from '@/assets/img/tree-radial.png';
import basicImg from '@/assets/img/tree-basic.png';
import graphImg from '@/assets/img/graph-webkit-dep.png';
import FalconLink from '@/components/common/FalconLink';
import { useOutletContext, useParams } from 'react-router-dom';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import { Link } from 'react-router-dom';
import DataLoadError from '@/components/errors/DataLoadError';
import { shouldShowDataLoadError, isNetworkApiError } from '@/app/common/utils/apiErrorUtils';
import NoCrawlData from '../components/common/NoCrawlData';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import { crawlTooltip } from '@/app/Crawl/tooltip/crawlTooltips';
import { useCountCrawlHistoryQuery } from '@/app/Crawl/api/historyApi';
import useDomain from '@/hooks/useDomain';
// صفحه نمایش گزینه های نمودار های گراف و درخت
type BreadcrumbItem = {
  text: string;
  href: string;
};

type CrawlOutletContext = [
  BreadcrumbItem[],
  Dispatch<SetStateAction<BreadcrumbItem[]>>
];

type CrawlHistoryResponse = {
  data?: Record<string, unknown>;
};

const Linkgraph = () => {
  const { slug } = useParams();
  const { domain_slug, domain } = useDomain();
  const [, setBreadcrumbData] = useOutletContext<CrawlOutletContext>();
  useEffect(() => {
    setBreadcrumbData([
      {
        text: 'گراف پیوند',
        href: `#`
      }
    ]);
  }, []);
  useGetUserInfoQuery();

  /* برای اینکه بفهمیم خزشی قبلا انجام داده یا نه */
  const {
    data: rawData,
    isLoading,
    isError,
    error,
    refetch,
    isFetching
  } = useCountCrawlHistoryQuery(domain_slug);
  const data = rawData as CrawlHistoryResponse | undefined;

  if (shouldShowDataLoadError(isError, error)) {
    return (
      <DataLoadError
        onRetry={() => refetch()}
        isRetrying={isFetching}
        isNetworkError={isNetworkApiError(error)}
      />
    );
  }
  if (!isLoading && !data?.data) return <NoCrawlData />;

  return (
    <Row className="g-3 mb-3 justify-content-center">
      <Col md={3}>
        {/* درخت پایه */}
        <Card
          as={Link}
          to={`/crawl/linkgraph/tree-basic/${slug}/${domain_slug}/${domain}`}
        >
          <FalconCardHeader
            title={
              <div>
                درخت پایه
                <HelpTooltip html={crawlTooltip.crawlerLinkGraph.tree} />
              </div>
            }
            titleTag="h6"
            className="py-2"
            light
          />
          <Card.Img
            loading="lazy"
            height={225}
            className="rounded-0"
            src={basicImg}
          />
          <Card.Footer className="text-end">
            <FalconLink
              title="بیشتر"
              decorative
              className="px-0 fw-medium"
            />
          </Card.Footer>
        </Card>
      </Col>
      <Col md={3}>
        {/* درخت مرکزی */}
        <Card
          as={Link}
          to={`/crawl/linkgraph/tree-radial/${slug}/${domain_slug}/${domain}`}
        >
          <FalconCardHeader
            title={
              <div>
                درخت مرکزی
                <HelpTooltip html={crawlTooltip.crawlerLinkGraph.circle} />
              </div>
            }
            titleTag="h6"
            className="py-2"
            light
          />
          <Card.Img
            loading="lazy"
            height={225}
            className="rounded-0"
            src={radialImg}
          />
          <Card.Footer className="text-end">
            <FalconLink
              title="بیشتر"
              decorative
              className="px-0 fw-medium"
            />
          </Card.Footer>
        </Card>
      </Col>
      <Col md={3}>
        {/* گراف */}
        <Card
          as={Link}
          to={`/crawl/linkgraph/graph/${slug}/${domain_slug}/${domain}`}
        >
          <FalconCardHeader
            title={
              <div>
                گراف
                <HelpTooltip html={crawlTooltip.crawlerLinkGraph.graph} />
              </div>
            }
            titleTag="h6"
            className="py-2"
            light
          />
          <Card.Img
            loading="lazy"
            height={225}
            className="rounded-0"
            src={graphImg}
          />
          <Card.Footer className="text-end">
            <FalconLink
              title="بیشتر"
              decorative
              className="px-0 fw-medium"
            />
          </Card.Footer>
        </Card>
      </Col>
    </Row>
  );
};

export default Linkgraph;
